import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    TOGGLE_SCHOOL_STATUS: {
        url: "bestuur/scholen/toggle",
        method: "post",
    },
};

export const useToggleSchoolStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.TOGGLE_SCHOOL_STATUS);